export const RECIPE = {
    wrapper:
        "relative block w-[212px] h-[212px] md:w-[284px] md:h-[284px] group rounded-[20px] overflow-hidden flex items-center justify-center transition hover:small-card-shadow mx-[10px] md:mx-[20px]",
    imageWrapper: "absolute inset-0",
    image: "object-cover w-full h-full transition scale-110 md:scale-100 group-hover:scale-110",
    title: "relative mx-[8px] w-fit text-center bg-mdlzPurple40 text-mdlzPurple px-[22px] py-[4.5px] uppercase rounded-[30px] label-text md:opacity-0 transition group-hover:opacity-100",
}
export const PRODUCT = {
    wrapper:
        "relative block w-[212px] h-[212px] md:w-[284px] md:h-[284px] group rounded-[20px] overflow-hidden flex items-center justify-center transition hover:small-card-shadow mx-[10px] md:mx-[20px]",
    imageWrapper: "absolute inset-0 bg-white",
    image: "object-cover w-full h-full transition scale-110 md:scale-100 group-hover:scale-110",
    title: "relative mx-[8px] w-fit text-center bg-mdlzPurple40 text-mdlzPurple px-[22px] py-[4.5px] uppercase rounded-[30px] label-text opacity-0 transition group-hover:opacity-100",
}
